import ManageFacebookPageSubscriptionsModal from './ManageFacebookPageSubscriptionsModal.vue';

export default ManageFacebookPageSubscriptionsModal;